<template>
  <div class="box addTreatmentProgramBox">
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.step1.title`) }}
    </p>
    <v-row
      v-for="(key, index) in keys"
      :key="index"
      class="xPadding"
    >
      <v-col class="py-0">
        <v-checkbox
          v-model="data[key]"
          class="check"
          :label="$t(`treatmentProgram.step1.${key}`)"
          hideDetails
          @change="updateData"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="data.other"
      class="xPadding"
    >
      <v-col>
        <VTextField
          v-model="data.otherText"
          :label="$t('treatmentProgram.step1.other')"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    name: 'Function',
    components: {
        VTextField,
    },
    props: {
        function: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            keys: ['oxygenScavenger', 'fouling', 'scaling', 'corrosion', 'other'],
        };
    },
    watch: {
        function: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.function) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { function: this.data });
        },
    },
};
</script>
  <style lang="scss" scoped>
  .xPadding{
    padding: 0 6rem;
  }
  .check {
      border: 1px solid #8D969F;
      border-radius: 4px;
      padding: 10px 5px;
      height: 56px;
      align-items: center;
  }
  .box {
      margin: auto;
      width: 650px;
  }

  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
      .text-field-transparent{
        margin-bottom:20px;
      }
  }

  @media screen and (max-width: 800px) {
     .addTreatmentProgramBox {
       width: 100% !important;
     }
  }

  </style>

  <style lang="scss">
    .addTreatmentProgramBox .v-input--selection-controls__input {
      margin-left: 5px;
    }
  </style>
